module.exports = __webpack_public_path__ + "media/assets/icons/trophy-68fac7f0ff537cbb979ce9de9d521062.svg";